// extracted by mini-css-extract-plugin
module.exports = {"selectedLanguageLabel":"LanguageDropdown_selectedLanguageLabel__1SyRf"};